export default __webpack_public_path__ + "assets/img/qt86Yb0.png";